import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import {
    tabularTypeDatasetAdapts,
    TabularTypeDatasetAdapter
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { GenericCDataTableDataset } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GenericCDataTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class GenericCDataTableDatasetAdapter extends TabularTypeDatasetAdapter<
    GenericCDataTableDataset,
    Model.DatasetResource
> {
    protected override async _toResource(
        dataset: GenericCDataTableDataset
    ): Promise<Model.DatasetResource> {
        return this._toResourceInternal(
            dataset,
            Metamodel.modelFor(GenericCDataTableDataset).name
        );
    }

    protected override async _toModel(
        resource: Model.DatasetResource,
        dataset?: GenericCDataTableDataset
    ): Promise<GenericCDataTableDataset> {
        return this._toModelInternal(resource, dataset, GenericCDataTableDataset.MODEL);
    }
}
